export default __webpack_public_path__ + "static/media/games_inactive.c6e4a654.svg";